<div class="w-full sm:px-2 hidden sm:block button-container" *ngIf="popupVisible" #popup>
    <!-- component -->
    <article id="article-article-550" class="news-list-item min-h-[14em]">
        <!-- left -->
        <div class="relative w-full sm:w-2/5 bg-grey-extra-light aspect-video">
            <img src="assets/images/placeholders/image-02.jpg" class="news-list-item-img" alt="placeholder 2">
        </div>
        <!-- right -->
        <div class="w-full p-3 leading-tight sm:w-3/5" style="position: relative;">
            <h4 class="font-bold italic uppercase text-xl mb-2 mt-2">AVERTISSEMENT</h4>
            <span class="text-sm text-blue uppercase font-medium">La SECF a été alertée sur des tentatives
                de manœuvres frauduleuses à l'occasion de transactions.</span>
            <div class="text-grey-medium text-xs mb-2">
                <span>09/09/2022 - </span>
                <span>la SECF&nbsp;</span>
                <span></span>
            </div>
            <div class="text-sm">
                <p>De soi-disant acheteurs potentiels proposent un règlement supérieur au prix convenu avec
                    un chèque qui ne peut être honoré. La plus grande vigilance est donc conseillée à ceux
                    qui souhaitent vendre leur chevaux et il leur est recommandé de réclamer le règlement de
                    la transaction soit par virement bancaire, soit par chèque certifié de banque.
                </p>
            </div>
            <div style="bottom: 0; right: 10px; padding-top: 10px;">
                <mat-checkbox class="example-margin" (change)="doNotShowAgain($event.checked)">
                    <span style="font-weight: 600">j'ai lu et j'ai pris connaissance</span>
                </mat-checkbox>
            </div>
        </div>
    </article>
  <button class="button" [disabled]="!checkboxChecked" (click)="closePopup()">Fermer</button>
</div>
